import { render, staticRenderFns } from "./industrial-park.vue?vue&type=template&id=f45e7a24&scoped=true&"
import script from "./industrial-park.vue?vue&type=script&lang=js&"
export * from "./industrial-park.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45e7a24",
  null
  
)

export default component.exports